/* eslint-disable import/prefer-default-export */
export const HEADER_BREAKPOINT = 800
export const HEADER_HEIGHT = 96
export const SHORT_HEADER_HEIGHT = 72
